import useJumboAuth from "@jumbo/hooks/useJumboAuth";

const Can = ({ role, children }) => {
  const { authUser } = useJumboAuth();

  const isAdmin = authUser?.role === "ADMIN" && role === "ADMIN";

  return isAdmin ? <>{children}</> : null;
};

export default Can;
